import React from 'react';
import './MapInfoSection.css';

const MapInfoSection = () => {
    return (<section className="map-info-section">
        <div className="legend-container">
            {/*<h3>Λεζάντα Χάρτη</h3>*/}
            <ul className="legend-list">
                <li>
                    <img src="/hospital.svg" alt="Κέντρα Εμπειρογνωμοσύνης" className="legend-icon"/>
                    <span>Κέντρα Εμπειρογνωμοσύνης</span>
                </li>
                <li>
                    <img src="/oc.svg" alt="Ειδικές Μονάδες / Ιατρεία" className="legend-icon"/>
                    <span>Ειδικές Μονάδες / Ιατρεία</span>
                </li>
                <li>
                    <img src="/vpo.svg" alt="Οργανώσεις Ασθενών μέλη Ε.Σ.Α.Ε" className="legend-icon"/>
                    <span>Οργανώσεις Ασθενών μέλη Ε.Σ.Α.Ε</span>
                </li>
                <li>
                    <img src="/nvpo.svg" alt="Οργανώσεις Ασθενών μη μέλη Ε.Σ.Α.Ε" className="legend-icon"/>
                    <span>Οργανώσεις Ασθενών μη μέλη Ε.Σ.Α.Ε</span>
                </li>
            </ul>
        </div>
        <div className="explanation-container">
            <p><b>Ο Χρήστης μπορεί να κάνει αναζήτηση μίας νόσου με πολλαπλούς τρόπους</b>:</p>
            <ul>
                <li>Πληκτρολογώντας την ονομασία της νόσου στα Ελληνικά ή στα Αγγλικά.</li>
                <li>Πληκτρολογώντας τον ORPHAcode, ο οποίος είναι μοναδικός για κάθε νόσο.</li>
                <li>Αναζητώντας τη νόσο στη λίστα του χάρτη και κάνοντας κλικ στην ονομασία της.</li>
            </ul>
            <p>
                Κάνοντας κλικ πάνω στην κάθε πινέζα, εμφανίζονται επιπλέον πληροφορίες, όπως η διεύθυνση, το τηλέφωνο
                επικοινωνίας, η ιστοσελίδα, το ΦΕΚ αναγνώρισης του Κέντρου Εμπειρογνωμοσύνης Σπάνιων και Πολύπλοκων
                Νοσημάτων, κ.λπ.
            </p>
            <p>
                <b>Πηγές:</b>{' '}
                <a href="https://www.orpha.net/" target="_blank" rel="noopener noreferrer">Orphanet</a>,{' '}
                <a href="https://pubmed.ncbi.nlm.nih.gov/" target="_blank" rel="noopener noreferrer">PubMed</a>,{' '}
                <a href="https://clinicaltrials.gov/" target="_blank" rel="noopener noreferrer">ClinicalTrials.gov</a>,{' '}
                <a href="https://www.clinicaltrialsregister.eu/about.html" target="_blank" rel="noopener noreferrer">European Union Clinical Trials Register</a>
            </p>
        </div>
    </section>);
};

export default MapInfoSection;
